import React from 'react';
import { ImageProps } from '.';

const SvgZexpressBasicKor = ({ size = 97, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 3.03125)) || 32} fill='none' viewBox='0 0 97 32' {...props}>
      <g clipPath='url(#ZexpressBasicKor_svg__a)'>
        <path
          fill='#6E52FF'
          d='M0 16C0 7.163 7.156 0 15.983 0h65.034C89.844 0 97 7.163 97 16s-7.156 16-15.983 16H15.983C7.156 32 0 24.837 0 16Z'
        />
        <path
          fill='#fff'
          d='M44.15 23.537h-2.067V19.98h-8.04v-1.65H44.15v5.206ZM72.504 23.537h-1.97v-7.42H69.21v6.74h-1.953V9.038h1.953v5.4h1.325v-5.61h1.97v14.71Z'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M80.408 18.3c3.196 0 5.102.953 5.118 2.634-.016 1.681-1.922 2.602-5.118 2.603-3.23 0-5.151-.922-5.151-2.603 0-1.68 1.922-2.634 5.15-2.635Zm0 1.567c-2.05 0-3.068.34-3.052 1.067-.016.727 1.001 1.067 3.052 1.067 2.001 0 3.035-.34 3.051-1.067-.016-.727-1.05-1.067-3.051-1.067Z'
          clipRule='evenodd'
        />
        <path
          fill='#fff'
          d='M50.343 21.63h8.154v1.648H48.26V18.51h2.083v3.12ZM19.835 9.361c4.263-.067 7.722 2.627 7.722 6.622l-.011.368c-.207 3.79-3.58 6.316-7.71 6.25-.79-.013-1.398-.11-2.256-.348-2.687-.75-7.977-3.951-9.775-5.284-.183-.135-.064-.407.167-.385l10.825 1.039c.165.016.26.183.18.32l-1.041 1.788c-.116.197.125.407.328.287l6.296-3.763a.315.315 0 0 0 0-.547l-6.296-3.763c-.203-.12-.444.09-.328.288l1.041 1.787c.078.137-.015.303-.18.32L7.972 15.38c-.23.021-.347-.251-.167-.385 1.798-1.333 7.088-4.537 9.775-5.287.858-.238 1.466-.335 2.255-.347Z'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M62.122 13.45h2.002v-3.313h1.906v9.908h-5.845v-9.908h1.937v3.313Zm0 4.947h2.002v-3.33h-2.002v3.33Z'
          clipRule='evenodd'
        />
        <path
          fill='#fff'
          d='M58.11 19.48h-2.068V8.844h2.067V19.48ZM54.492 11.527h-2.954v.21c0 1.762 1.081 3.556 3.503 4.283l-1.05 1.617c-1.646-.517-2.809-1.576-3.47-2.91-.67 1.447-1.866 2.61-3.585 3.185l-1.066-1.617c2.438-.792 3.569-2.7 3.569-4.558v-.21h-3.02V9.878h8.073v1.649ZM44.15 17.685h-2.067V8.828h2.067v8.857ZM81.425 15.843h5.7v1.648H73.723v-1.648h5.667v-1.81h2.035v1.81ZM40.533 11.333h-2.955c.016 1.721 1.098 3.532 3.504 4.251l-1.05 1.6c-1.646-.509-2.809-1.568-3.47-2.91-.67 1.455-1.866 2.611-3.585 3.185l-1.066-1.6c2.422-.784 3.552-2.692 3.568-4.526h-3.02V9.684h8.074v1.649Z'
        />
        <path
          fill='#fff'
          d='M81.457 9.555c0 1.713 1.647 3.346 4.957 3.75l-.791 1.6c-2.478-.372-4.303-1.414-5.232-2.893-.944 1.479-2.769 2.53-5.247 2.893l-.727-1.6c3.245-.404 4.941-2.085 4.941-3.75V9.07h2.1v.485Z'
        />
      </g>
      <defs>
        <clipPath id='ZexpressBasicKor_svg__a'>
          <path fill='#fff' d='M0 0h97v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgZexpressBasicKor;
